import PlanejamentoContratoFormAcoes from '../../../../produto/spa/planejamento-contrato/form/passo-acoes/PlanejamentoContratoFormAcoes';

export default PlanejamentoContratoFormAcoes;
